import { useEffect, useMemo, useRef, useState } from 'react'
import { useSession } from 'next-auth/react'

import styles from './styles.module.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faChevronDown, faChevronLeft, faMapLocationDot, faPlusSquare, faXmark } from '@fortawesome/free-solid-svg-icons';

import { PulseLoader } from 'react-spinners';
import GridDragAndDrop from '../../../../Misc/GridDragAndDrop/GridDragAndDrop';

import MapWithLocation from '../../../../Misc/MapWithLocation/MapWithLocation';

export default function JobPost({ setMapType, showPolicyPage, pendingRequest, handleCreateListing }) {

    const { data: session } = useSession();

    const [uploads, setUploads] = useState([]);

    const [title, setTitle] = useState("");

    const [propertyAddress, setPropertyAddress] = useState("");
    const [propertyCity, setPropertyCity] = useState("");
    const [zip, setZIP] = useState('');

    const [desc, setDesc] = useState("");

    const [website, setWebsite] = useState("");

    const [phoneNumber, setPhoneNumber] = useState("");

    useEffect(() => {
        if((zip.length === 5 || zip.length === 10) && propertyAddress.length >= 8 && propertyCity.length >= 3) {
            setMapType({ type: "Location", address: propertyAddress, city: propertyCity, zip: zip });
        } else {
            setMapType(null);
        }
    }, [zip, propertyAddress, propertyCity])

    const handleZIPChange = (e) => {
        let inputValue = e.target.value;

        inputValue = inputValue.replace(/\D/g, '');

        if (inputValue.length > 5) {
          inputValue = inputValue.slice(0, 5) + '-' + inputValue.slice(5);
        }

        inputValue = inputValue.slice(0, 10);

        setZIP(inputValue);
    };

    const handlePhoneChange = (event) => {
        const input = event.target.value.replace(/\D/g, ''); // Remove non-numeric characters
        let formattedPhoneNumber = '';
        
        if (input.length >= 4 && input.length <= 7) {
          formattedPhoneNumber = `(${input.slice(0, 3)}) ${input.slice(3)}`;
        } else if (input.length > 7) {
          formattedPhoneNumber = `(${input.slice(0, 3)}) ${input.slice(3, 6)}-${input.slice(6, 10)}`;
        } else {
          formattedPhoneNumber = input;
        }
        
        setPhoneNumber(formattedPhoneNumber);
      };

    const [businessCategory, setBusinessCategory] = useState('Business Category');
    const [categoryMenu, showCategoryMenu] = useState(false);

    const changeBusinessCategory = (e, category) => {
        e.preventDefault();
        if(category === businessCategory) return;
        setBusinessCategory(category);
        showCategoryMenu(false);
    }

    function handleSubmit() {

        const listingData = {
            owner: session.user.token.username,
            title: title,
            category: businessCategory,
            propertyAddress: propertyAddress,
            propertyCity: propertyCity,
            zip: zip,
            description: desc,
            website: website,
            contactPhone: phoneNumber,
            toUpload: uploads,
            creationDate: new Date().toISOString()
        }

        handleCreateListing(listingData);
    }

    const [canSubmit, setCanSubmit] = useState(false);

    useEffect(() => {
        if(uploads.length === 0 ||
        title.length < 5 || title.length > 50 ||
        propertyAddress.length < 8 ||
        propertyCity.length < 2 ||
        businessCategory === 'Business Category' ||
        zip.length < 5) {
            setCanSubmit(false);
        } else {
            setCanSubmit(true);
        }
    }, [uploads, title, desc, propertyAddress, propertyCity, businessCategory, zip])

    const memoizeImageGrid = useMemo(() => <GridDragAndDrop initialImages={null} pendingRequest={pendingRequest} receiveUploadData={(newUploads) => setUploads(newUploads)}  />, [pendingRequest])

    return (
        <section id={styles.createtrade}>

            <section id={styles.wrapper}>

                <div id={styles.gridContainer}>
                    <h1>{uploads.length} / 12 slots available</h1>
                    { memoizeImageGrid }
                </div>

                <div id={styles.enterInfo}>
                    <h1>Listing Details</h1>

                    <section id={styles.title}>
                        <input disabled={pendingRequest} onChange={(e) => setTitle(e.target.value)} type='text' placeholder="Business Name" maxLength={50} />
                        {title !== null && ( title.length < 5 && <h6>{title.length - 5}</h6> )}
                    </section>

                    <div onMouseLeave={() => showCategoryMenu(false)} className={styles.dropdown}>
                    <button disabled={pendingRequest} style={{color: businessCategory === 'Business Category' ? '#818181' : 'black'}} onClick={ (e) => {e.preventDefault(); showCategoryMenu(categoryMenu ? false : true)} } className={styles.dropdownBtn}>{businessCategory} <FontAwesomeIcon icon={faChevronDown} id={styles.icon} /></button>
                        <div style={{height: '200px', display: categoryMenu === false ? 'none' : 'block'}} className={styles.dropdownContent}>
                            <button onClick={(e) => changeBusinessCategory(e, 'Antique Shop')}>Antique Shop</button>
                            <button onClick={(e) => changeBusinessCategory(e, 'Art Gallery')}>Art Gallery</button>
                            <button onClick={(e) => changeBusinessCategory(e, 'Bakery')}>Bakery</button>
                            <button onClick={(e) => changeBusinessCategory(e, 'Bakery Cafe')}>Bakery Cafe</button>
                            <button onClick={(e) => changeBusinessCategory(e, 'Barber Shop')}>Barber Shop</button>
                            <button onClick={(e) => changeBusinessCategory(e, 'BBQ Joint')}>BBQ Joint</button>
                            <button onClick={(e) => changeBusinessCategory(e, 'Bookstore')}>Bookstore</button>
                            <button onClick={(e) => changeBusinessCategory(e, 'Boutique')}>Boutique</button>
                            <button onClick={(e) => changeBusinessCategory(e, 'Burger Joint')}>Burger Joint</button>
                            <button onClick={(e) => changeBusinessCategory(e, 'Cafe')}>Cafe</button>
                            <button onClick={(e) => changeBusinessCategory(e, 'Chinese Restaurant')}>Chinese Restaurant</button>
                            <button onClick={(e) => changeBusinessCategory(e, 'Coffee Shop')}>Coffee Shop</button>
                            <button onClick={(e) => changeBusinessCategory(e, 'Construction')}>Construction</button>
                            <button onClick={(e) => changeBusinessCategory(e, 'Consulting')}>Consulting</button>
                            <button onClick={(e) => changeBusinessCategory(e, 'Craft Brewery')}>Craft Brewery</button>
                            <button onClick={(e) => changeBusinessCategory(e, 'Crystals Shop')}>Crystals Shop</button>
                            <button onClick={(e) => changeBusinessCategory(e, 'Dance Studio')}>Dance Studio</button>
                            <button onClick={(e) => changeBusinessCategory(e, 'Delicatessen')}>Delicatessen</button>
                            <button onClick={(e) => changeBusinessCategory(e, 'Diner')}>Diner</button>
                            <button onClick={(e) => changeBusinessCategory(e, 'Education')}>Education</button>
                            <button onClick={(e) => changeBusinessCategory(e, 'Entertainment')}>Entertainment</button>
                            <button onClick={(e) => changeBusinessCategory(e, 'Farmers Market')}>Farmers Market</button>
                            <button onClick={(e) => changeBusinessCategory(e, 'Fast Food')}>Fast Food</button>
                            <button onClick={(e) => changeBusinessCategory(e, 'Finance')}>Finance</button>
                            <button onClick={(e) => changeBusinessCategory(e, 'Fitness Center')}>Fitness Center</button>
                            <button onClick={(e) => changeBusinessCategory(e, 'Florist')}>Florist</button>
                            <button onClick={(e) => changeBusinessCategory(e, 'Food Truck')}>Food Truck</button>
                            <button onClick={(e) => changeBusinessCategory(e, 'French Restaurant')}>French Restaurant</button>
                            <button onClick={(e) => changeBusinessCategory(e, 'Healthcare')}>Healthcare</button>
                            <button onClick={(e) => changeBusinessCategory(e, 'Hospitality')}>Hospitality</button>
                            <button onClick={(e) => changeBusinessCategory(e, 'Ice Cream Shop')}>Ice Cream Shop</button>
                            <button onClick={(e) => changeBusinessCategory(e, 'Indian Restaurant')}>Indian Restaurant</button>
                            <button onClick={(e) => changeBusinessCategory(e, 'Italian Restaurant')}>Italian Restaurant</button>
                            <button onClick={(e) => changeBusinessCategory(e, 'Juice Bar')}>Juice Bar</button>
                            <button onClick={(e) => changeBusinessCategory(e, 'Legal')}>Legal</button>
                            <button onClick={(e) => changeBusinessCategory(e, 'Manufacturing')}>Manufacturing</button>
                            <button onClick={(e) => changeBusinessCategory(e, 'Marketing')}>Marketing</button>
                            <button onClick={(e) => changeBusinessCategory(e, 'Mexican Restaurant')}>Mexican Restaurant</button>
                            <button onClick={(e) => changeBusinessCategory(e, 'Music Store')}>Music Store</button>
                            <button onClick={(e) => changeBusinessCategory(e, 'Nail Salon')}>Nail Salon</button>
                            <button onClick={(e) => changeBusinessCategory(e, 'Non-Profit')}>Non-Profit</button>
                            <button onClick={(e) => changeBusinessCategory(e, 'Pet Grooming')}>Pet Grooming</button>
                            <button onClick={(e) => changeBusinessCategory(e, 'Pizzeria')}>Pizzeria</button>
                            <button onClick={(e) => changeBusinessCategory(e, 'Real Estate')}>Real Estate</button>
                            <button onClick={(e) => changeBusinessCategory(e, 'Restaurant')}>Restaurant</button>
                            <button onClick={(e) => changeBusinessCategory(e, 'Salon')}>Salon</button>
                            <button onClick={(e) => changeBusinessCategory(e, 'Sandwich Shop')}>Sandwich Shop</button>
                            <button onClick={(e) => changeBusinessCategory(e, 'Seafood Restaurant')}>Seafood Restaurant</button>
                            <button onClick={(e) => changeBusinessCategory(e, 'Spa')}>Spa</button>
                            <button onClick={(e) => changeBusinessCategory(e, 'Steakhouse')}>Steakhouse</button>
                            <button onClick={(e) => changeBusinessCategory(e, 'Sushi Bar')}>Sushi Bar</button>
                            <button onClick={(e) => changeBusinessCategory(e, 'Tattoo Shop')}>Tattoo Shop</button>
                            <button onClick={(e) => changeBusinessCategory(e, 'Technology')}>Technology</button>
                            <button onClick={(e) => changeBusinessCategory(e, 'Telecommunications')}>Telecommunications</button>
                            <button onClick={(e) => changeBusinessCategory(e, 'Thai Restaurant')}>Thai Restaurant</button>
                            <button onClick={(e) => changeBusinessCategory(e, 'Taco Stand')}>Taco Stand</button>
                            <button onClick={(e) => changeBusinessCategory(e, 'Transportation')}>Transportation</button>
                            <button onClick={(e) => changeBusinessCategory(e, 'Vegan Restaurant')}>Vegan Restaurant</button>
                            <button onClick={(e) => changeBusinessCategory(e, 'Vegetarian Restaurant')}>Vegetarian Restaurant</button>
                            <button onClick={(e) => changeBusinessCategory(e, 'Winery')}>Winery</button>
                            <button onClick={(e) => changeBusinessCategory(e, 'Yoga Studio')}>Yoga Studio</button>
                            <button onClick={(e) => changeBusinessCategory(e, 'Other')}>Other</button>
                        </div>
                    </div>

                    <section id={styles.addLocation}>
                        <input disabled={pendingRequest} onChange={(e) => setPropertyAddress(e.target.value)} type='text' placeholder="Address" value={propertyAddress} />
                        <div>
                            <input disabled={pendingRequest} onChange={(e) => setPropertyCity(e.target.value)} type='text' placeholder="City" value={propertyCity} />
                            <input disabled={pendingRequest} onChange={handleZIPChange} type='text' placeholder="ZIP Code" maxLength={10} value={zip} />
                        </div>
                    </section>

                    <ListingMap address={propertyAddress} city={propertyCity} zip={zip} />

                    <h1>Additional Details</h1>

                    <input disabled={pendingRequest} type='text' placeholder="(123)-456-7890" onChange={handlePhoneChange} value={phoneNumber} />
                    <input disabled={pendingRequest} type='url' onChange={(e) => setWebsite(e.target.value)} placeholder="Website URL" />

                    <section id={styles.desc}>
                        <textarea disabled={pendingRequest} onChange={(e) => setDesc(e.target.value)} placeholder="Description" maxLength={2000} />
                    </section>

                    <p>Businesses are public and can be seen by anyone on or off Waco Exchange. Businesses promoting explicit content, abuse, or other forms of unethical behavior aren't allowed on Waco Exchange. See our <b onClick={() => showPolicyPage(true)}>Policy Page</b> for more info.</p>
                    <button disabled={!canSubmit} onClick={handleSubmit} id={styles.createListing}>
                        { pendingRequest === true ? <PulseLoader size={15} color='white' /> : <> Create Listing <FontAwesomeIcon icon={faPlusSquare} id={styles.icon} /> </>}
                    </button>

                </div>
            </section>
        </section>
    )
}

const ListingMap = ({ address, city, zip }) => {

    function isMapViewable() {
        if(zip === null || zip === undefined) return false;
        if(zip.length === 5 || zip.length === 10) return true;
        return false;
    }

    return (
        <section id={styles.listingInteractiveMap}>
            { isMapViewable() && <MapWithLocation address={address} city={city} zipCode={zip} /> }
            { !isMapViewable() && <FontAwesomeIcon icon={faMapLocationDot} id={styles.icon} /> }
        </section>
    )
}